export default __webpack_public_path__ + "static/media/pic2.28ae342a.jpg";